import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import Page1 from "./page1";
import Page2 from "./page2";

function Page() {
  const [articleContent, setArticleContent] = useState({});
  const [sliderContent, setSliderContent] = useState([]);
  const [albumSliderContent, setAlbumSliderContent] = useState([]);
  const [pageSliderContent, setPageSliderContent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let location = useLocation();

  const handleAlbumClick = useCallback(
    (e) => {
      let albumID = e.currentTarget.getAttribute("data-id");
      axios
        .post("/api/website/getAlbumContent", { albumId: albumID * 1 })
        .then((response) => {
          setSliderContent(response.data.data.slider);
        })
        .catch((error) => {
          console.error("Error fetching article content:", error);
        });
    },
    [setSliderContent]
  );

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    let id = searchParams.get("id");

    setIsLoading(true);
    axios
      .post("/api/website/getPage", { id: id * 1 })
      .then((response) => {
        console.log(response.data.data);
        setArticleContent(response.data.data.result);
        setAlbumSliderContent(response.data.data.album);
        setSliderContent(response.data.data.slider);
        setPageSliderContent(response.data.data.pageSlider || []);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [location.search]);

  // 切換到 /page 或 id 變更時，強制滾動至頂部
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search]);

  return (
    <>
      <Navbar />
      {!isLoading && articleContent && Object.keys(articleContent).length > 0 && (
        articleContent.typeId === 1 ? (
          <Page1
            articleContent={articleContent}
            sliderContent={sliderContent}
            albumSliderContent={albumSliderContent}
            pageSliderContent={pageSliderContent}
            handleAlbumClick={handleAlbumClick}
          />
        ) : articleContent.typeId === 2 ? (
          <Page2
            articleContent={articleContent}
            sliderContent={sliderContent}
            albumSliderContent={albumSliderContent}
            pageSliderContent={pageSliderContent}
            handleAlbumClick={handleAlbumClick}
          />
        ) : null
      )}
      <Footer />
    </>
  );
}

export default Page;
